import React from 'react';
import { useAppSelector } from '../../../../redux/hooks';
import Box from '@mui/material/Box';
import Transcription from './transcription/Transcription';
import Document from './document/Document';

interface NoteProps {
    isMobile: boolean;
}

const Note: React.FC<NoteProps> = ({ isMobile }) => {
    const colors = useAppSelector(state => state.theme.colors);

    return (
        <Box sx={{
            // Common styles
            height: '100%', // Takes full height from parent Container
            boxSizing: 'border-box',
            backgroundColor: colors?.interface, // Background for the area

            // Conditional styles based on isMobile
            ...(isMobile ? {
                // --- Mobile Styles ---
                display: 'flex',            // Use flexbox for vertical stacking
                flexDirection: 'column',    // Stack children vertically
                alignItems: 'stretch',      // Make children take full width
                width: '100%',              // Take full width of the screen
                position: 'relative',       // Relative positioning for normal flow layout
                overflowY: 'auto',          // Enable vertical scrolling *for the Note container*
                overflowX: 'hidden',        // Disable horizontal scrolling
                padding: '8px',             // Add padding around the content
                flexWrap: 'nowrap',         // Prevent wrapping
            } : {
                // --- Desktop Styles ---
                display: 'block',           // Use block or relative as positioning context
                position: 'absolute',       // Absolutely position Note container itself
                width: 'calc(100% - 19.5% - 1%)', // Original width calculation beside sidebar
                overflow: 'hidden',         // Hide overflow (children are positioned absolutely)
                right: 0,                   // Position from right
                bottom: 0,                  // Position from bottom
                left: 'calc(19.5% + 1%)',   // Position from left (after sidebar)
                padding: 0,                 // No padding
            })
        }}>
            {/* Render children directly, passing the isMobile prop */}
            {/* Children components MUST handle their own conditional styling */}
            <Transcription isMobile={isMobile} />
            <Document isMobile={isMobile} />
        </Box>
    );
};

export default Note;